import React, { useEffect, useRef } from "react";

const useDidMountEffect = (effect: React.EffectCallback, deps?: React.DependencyList) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) return effect();
        else didMount.current = true;
    }, deps);
};

export default useDidMountEffect;